import apiClient from "../../http";
import {
  PROFILE_CREATE_FAIL,
  PROFILE_CREATE_REQUEST,
  PROFILE_CREATE_SUCCESS,
  PROFILE_EDIT_FAIL,
  PROFILE_EDIT_REQUEST,
  PROFILE_EDIT_SUCCESS,
  PROFILE_UPDATE_FAIL,
  PROFILE_UPDATE_REQUEST,
  PROFILE_UPDATE_SUCCESS,
  PROFILE_LIST_FAIL,
  PROFILE_LIST_REQUEST,
  PROFILE_LIST_SUCCESS,
  PROFILE_LIST_RESET,
} from "../Constants/ProfileConstants";
import {
  getAllProfiles,
  getProfileLastFetchDate,
  insertOrUpdateProfile,
  getProfileByBusinessId,
} from "../../utils/database";

// CREATE PROFILE (Public API - No Auth Required)
export const createProfile = (profile) => async (dispatch) => {
  try {
    dispatch({ type: PROFILE_CREATE_REQUEST });

    const result = await apiClient.post(`/profile/create`, profile);

    // Cache to IndexedDB
    await insertOrUpdateProfile(result.data);

    dispatch({ type: PROFILE_CREATE_SUCCESS, payload: result.data });
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({ type: PROFILE_CREATE_FAIL, payload: message });
  }
};

// EDIT PROFILE (Protected API - Requires Auth)
// export const editProfile = (businessId) => async (dispatch) => {
//   return new Promise(async (resolve) => {
//     try {
//       dispatch({ type: PROFILE_EDIT_REQUEST });

//       const { data } = await apiClient.get(
//         `profile/get/${businessId.split("#")[1]}`,
//         { requiresAuth: true } // This tells Axios to add the token
//       );

//       dispatch({
//         type: PROFILE_EDIT_SUCCESS,
//         payload: { item: data },
//       });
//       resolve(data);
//     } catch (error) {
//       const message = error.response?.data?.message || error.message;
//       dispatch({ type: PROFILE_EDIT_FAIL, payload: message });
//     }
//   });
// };

export const editProfile =
  (businessId, getFromCache = true) =>
  async (dispatch) => {
    return new Promise(async (resolve) => {
      try {
        dispatch({ type: PROFILE_EDIT_REQUEST });

        if (getFromCache) {
          const localProfile = await getProfileByBusinessId(businessId);

          if (localProfile) {
            dispatch({
              type: PROFILE_EDIT_SUCCESS,
              payload: { item: localProfile },
            });
            return resolve(localProfile);
          }
        }

        const { data } = await apiClient.get(`profile/get/${businessId}`, {
          requiresAuth: true,
        });

        // Save to local
        if (data) await insertOrUpdateProfile(data);

        dispatch({
          type: PROFILE_EDIT_SUCCESS,
          payload: { item: data },
        });
        resolve(data);
      } catch (error) {
        const message = error.response?.data?.message || error.message;
        dispatch({ type: PROFILE_EDIT_FAIL, payload: message });
      }
    });
  };

// UPDATE PROFILE (Protected API - Requires Auth)
export const updateProfile = (profile) => async (dispatch) => {
  return new Promise(async (resolve) => {
    try {
      dispatch({ type: PROFILE_UPDATE_REQUEST });

      console.log("[PROFILE UPDATE] Sending profile:", profile);

      const { data } = await apiClient.put("/profile/update", profile, {
        requiresAuth: true,
      });

      console.log("[PROFILE UPDATE] API response:", data);

      console.log("[PROFILE UPDATE] Response phone:", profile?.phone);
      console.log(
        "[PROFILE UPDATE] Response whatsappPhone:",
        profile?.whatsappPhone,
      );
      console.log("[PROFILE UPDATE] Response updatedAt:", profile?.updatedAt);

      await insertOrUpdateProfile(profile);

      console.log("[PROFILE UPDATE] Local cache updated");

      dispatch({ type: PROFILE_UPDATE_SUCCESS, payload: data });
      resolve(data);
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      dispatch({ type: PROFILE_UPDATE_FAIL, payload: message });
    }
  });
};

// GET PROFILES (Public API - No Auth Required)
// export const listProfile =
//   (filters = {}) =>
//   async (dispatch) => {
//     return new Promise(async (resolve) => {
//       try {
//         dispatch({ type: PROFILE_LIST_REQUEST });

//         const { data } = await apiClient.post(`profiles`, filters);

//         dispatch({
//           type: PROFILE_LIST_SUCCESS,
//           payload: {
//             items: data.items,
//             nextStartKey: data.nextStartKey,
//             pages: data.pages,
//           },
//         });
//         resolve(data);
//       } catch (error) {
//         const message = error.response?.data?.message || error.message;
//         dispatch({ type: PROFILE_LIST_FAIL, payload: message });
//       }
//     });
//   };
export const listProfile_0 = (filters) => async (dispatch) => {
  return new Promise(async (resolve) => {
    try {
      dispatch({ type: PROFILE_LIST_REQUEST });

      const lastFetchDateStr = await getProfileLastFetchDate(); // assuming this is now a Promise

      const lastFetchDate = lastFetchDateStr
        ? new Date(lastFetchDateStr)
        : null;

      const isRecent =
        lastFetchDate !== null &&
        new Date().getTime() - lastFetchDate.getTime() < 5 * 60 * 1000; // 5 min

      if (isRecent) {
        // Fetch only from local DB if data is recent
        const localProfiles = await getAllProfiles();

        dispatch({
          type: PROFILE_LIST_SUCCESS,
          payload: {
            items: localProfiles,
            nextStartKey: null,
            hasMore: false,
          },
        });
        return resolve({ source: "local", items: localProfiles });
      }

      // Else, fetch from backend
      const newFilters = {
        ...filters,
        lastFetchDate: lastFetchDateStr,
      };

      const { data } = await apiClient.post(`profiles`, newFilters);
      const nextStartKey = data.nextStartKey;
      const hasMore = data.hasMore;

      // Save to local DB
      if (data.items?.length > 0) {
        data.items.forEach(insertOrUpdateProfile);
      }

      // Read from local DB
      const localProfiles = await getAllProfiles();

      dispatch({
        type: PROFILE_LIST_SUCCESS,
        payload: {
          items: localProfiles,
          nextStartKey: nextStartKey,
          hasMore: hasMore,
        },
      });

      resolve({ source: "api", items: data.items });
    } catch (error) {
      dispatch({
        type: PROFILE_LIST_FAIL,
        payload: error.message,
      });
    }
  });
};

export const listProfile =
  (filters, append = false) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: PROFILE_LIST_REQUEST });

      const { profileList } = getState();

      const { data } = await apiClient.post("profiles", {
        ...filters,
        startKey: append ? profileList.nextStartKey : null,
        pageSize: 20,
      });

      dispatch({
        type: PROFILE_LIST_SUCCESS,
        payload: data,
        append,
        filters,
      });
    } catch (error) {
      dispatch({
        type: PROFILE_LIST_FAIL,
        payload: error.message,
      });
    }
  };

export const clearProfiles = () => ({
  type: PROFILE_LIST_RESET,
});
